const config = process.env;
const normalize = (value: string | undefined) => value?.trim();
const runtimeEnv = normalize(config.REACT_APP_ENV)?.toUpperCase();

// Classic (legacy) UI stays enabled unless explicitly set to 'false'.
const legacyUiEnabled =
  normalize(config.REACT_APP_LEGACY_UI_ENABLED)?.toLowerCase() !== 'false';

const appSettings = {
  LEGACY_UI_ENABLED: legacyUiEnabled,
  ENV: '',
  APIM_URL: '',
  WEATHER_OVERRIDE_URL: '',
  OIDC_PROVIDER: '',
  OIDC_CLIENT_ID: '',
  OIDC_REDIRECT_ROUTE: '',
  OIDC_END_SESSION_ENDPOINT: '',
  APPINSIGHTS_CONNECTION_STRING: '',
  HARNESSKEY: '',
};

// Development
if (runtimeEnv === 'DEV') {
  appSettings.ENV = runtimeEnv;
  appSettings.WEATHER_OVERRIDE_URL = config.REACT_APP_DEV_WEATHER_OVERRIDE_URL;
  appSettings.OIDC_PROVIDER = config.REACT_APP_DEV_OIDC_PROVIDER;
  appSettings.OIDC_CLIENT_ID = config.REACT_APP_DEV_OIDC_CLIENT_ID;
  appSettings.OIDC_REDIRECT_ROUTE = config.REACT_APP_DEV_OIDC_REDIRECT_ROUTE;
  appSettings.OIDC_END_SESSION_ENDPOINT =
    config.REACT_APP_DEV_OIDC_END_SESSION_ENDPOINT;
  appSettings.APPINSIGHTS_CONNECTION_STRING =
    config.REACT_APP_DEV_APPINSIGHTS_CONNECTION_STRING;
  appSettings.APIM_URL = config.REACT_APP_APIM_DEV_BASE_URL;
  appSettings.HARNESSKEY =
    normalize(config.REACT_APP_DEV_HARNESS_API_KEY) || '';
}
// TEST
else if (runtimeEnv === 'TEST') {
  appSettings.ENV = runtimeEnv;
  appSettings.WEATHER_OVERRIDE_URL = config.REACT_APP_TEST_WEATHER_OVERRIDE_URL;
  appSettings.OIDC_PROVIDER = config.REACT_APP_TEST_OIDC_PROVIDER;
  appSettings.OIDC_CLIENT_ID = config.REACT_APP_TEST_OIDC_CLIENT_ID;
  appSettings.OIDC_REDIRECT_ROUTE = config.REACT_APP_TEST_OIDC_REDIRECT_ROUTE;
  appSettings.OIDC_END_SESSION_ENDPOINT =
    config.REACT_APP_TEST_OIDC_END_SESSION_ENDPOINT;
  appSettings.APPINSIGHTS_CONNECTION_STRING =
    config.REACT_APP_TEST_APPINSIGHTS_CONNECTION_STRING;
  appSettings.APIM_URL = config.REACT_APP_APIM_TEST_BASE_URL;
  appSettings.HARNESSKEY =
    normalize(config.REACT_APP_TEST_HARNESS_API_KEY) || '';
}
// QA
else if (runtimeEnv === 'QA') {
  appSettings.ENV = runtimeEnv;
  appSettings.WEATHER_OVERRIDE_URL = config.REACT_APP_QA_WEATHER_OVERRIDE_URL;
  appSettings.OIDC_PROVIDER = config.REACT_APP_QA_OIDC_PROVIDER;
  appSettings.OIDC_CLIENT_ID = config.REACT_APP_QA_OIDC_CLIENT_ID;
  appSettings.OIDC_REDIRECT_ROUTE = config.REACT_APP_QA_OIDC_REDIRECT_ROUTE;
  appSettings.OIDC_END_SESSION_ENDPOINT =
    config.REACT_APP_QA_OIDC_END_SESSION_ENDPOINT;
  appSettings.APPINSIGHTS_CONNECTION_STRING =
    config.REACT_APP_QA_APPINSIGHTS_CONNECTION_STRING;
  appSettings.APIM_URL = config.REACT_APP_APIM_QA_BASE_URL;
  appSettings.HARNESSKEY = normalize(config.REACT_APP_QA_HARNESS_API_KEY) || '';
}
// PROD
else if (runtimeEnv === 'PROD') {
  appSettings.ENV = runtimeEnv;
  appSettings.WEATHER_OVERRIDE_URL = config.REACT_APP_PROD_WEATHER_OVERRIDE_URL;
  appSettings.OIDC_PROVIDER = config.REACT_APP_PROD_OIDC_PROVIDER;
  appSettings.OIDC_CLIENT_ID = config.REACT_APP_PROD_OIDC_CLIENT_ID;
  appSettings.OIDC_REDIRECT_ROUTE = config.REACT_APP_PROD_OIDC_REDIRECT_ROUTE;
  appSettings.OIDC_END_SESSION_ENDPOINT =
    config.REACT_APP_PROD_OIDC_END_SESSION_ENDPOINT;
  appSettings.APPINSIGHTS_CONNECTION_STRING =
    config.REACT_APP_PROD_APPINSIGHTS_CONNECTION_STRING;
  appSettings.APIM_URL = config.REACT_APP_APIM_PROD_BASE_URL;
  appSettings.HARNESSKEY =
    normalize(config.REACT_APP_PROD_HARNESS_API_KEY) || '';
}

export default appSettings;
